import React, { useState, useEffect } from 'react'
import { Link, useLocation, useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'

import { setSidebar, signOutUser } from '../../redux/actions'
import { clearSession } from '../../api'

const Sidebar = () => {
    const dispatch = useDispatch()
    const history = useHistory()
    const { sidebar } = useSelector(state => state.config)

    const location = useLocation()
    const [, name] = location.pathname.split('/')

    useEffect(() => {
        dispatch(setSidebar(name))
    }, [name])

    const sidebarItems = [
        { type: 'activites', label: 'Activités' },
        { type: 'offres', label: 'Offres' },
        { type: 'formules', label: 'Formules' },
        { type: 'accessoires', label: 'Accessoires' },
        { type: 'codepromos', label: 'Code Promo' },
        { type: 'configurations', label: 'Configurations' }
    ]

    const signOut = () => {
        clearSession()
        dispatch(signOutUser())
        history.push('/')
    }

    return (
        <div className="sidebar">
            <div className="sidebar__mainWrapper" style={{ height: '100vh' }}>
                <Link to='/activites' className="sidebar__logoWrapper">
                    <img className="sidebar__logo" src="/img/logo.png" alt='logo' />
                </Link>
                <div className="sidebar__wrapper">
                    {sidebarItems.map(({ type, label }, index) => <Link key={index} to={`/${type}`} onClick={() => dispatch(setSidebar(type))} className={type.includes(sidebar) ? "sidebar__barItem sidebar__barItem-active" : "sidebar__barItem"}>{label}</Link>)}
                    <div onClick={signOut} className="sidebar__barItem sidebar__barItem-logout" style={{ marginTop: 'auto', cursor: 'pointer' }}>
                        <img className='sidebar__iconItem' src='/img/icon/logout.svg' />
                        Déconnexion
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Sidebar